import { message } from 'antd';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { addReportToMyLibraryAPI, fetchNewUserCasesAPI } from '../../../services/user-case-service';
import { ADD_USER_CASE_TO_MY_LIBRARY, ADD_USER_CASE_TO_MY_LIBRARY_ERROR, ADD_USER_CASE_TO_MY_LIBRARY_SUCCESS, FETCH_NEW_USER_CASES, FETCH_NEW_USER_CASES_ERROR, FETCH_NEW_USER_CASES_START, FETCH_NEW_USER_CASES_SUCCESS } from '../../actions/NewCasesAction';

function* fetchNewUserCases({ }) {

    try {
        yield put({ type: FETCH_NEW_USER_CASES_START })
        let response = yield call(fetchNewUserCasesAPI);
        if (response.success) {
            yield put({ type: FETCH_NEW_USER_CASES_SUCCESS, newCases: response.data })
        } else {
            yield put({ type: FETCH_NEW_USER_CASES_ERROR });
            message.error('Failed to fetch new user cases!');
        }

    } catch (error) {
        message.error('Failed to fetch new user cases!');
        yield put({ type: FETCH_NEW_USER_CASES_ERROR, error })
    }
}

function* addUpdateNewUserCaseToMyLibrary({ payload }) {
    try {
        let response = yield call(addReportToMyLibraryAPI, payload);
        if (response.success) {
            yield put({ type: ADD_USER_CASE_TO_MY_LIBRARY_SUCCESS, userCase: response.data })
            message.success('Added user case to my library successfully.');
        } else {
            if (response.error === "query did not return a unique result: 2; nested exception is javax.persistence.NonUniqueResultException: query did not return a unique result: 2") {
                message.error('Failed to add user case to my library!');
            } else {
                message.error(response.error);
            }

        }
    } catch (error) {
        message.error(error);

    }
}


function* newUserCasesWatcher() {
    yield takeLatest(FETCH_NEW_USER_CASES, fetchNewUserCases)
    yield takeLatest(ADD_USER_CASE_TO_MY_LIBRARY, addUpdateNewUserCaseToMyLibrary)
}

export default function* rootSaga() {
    yield all([
        newUserCasesWatcher()
    ]);
}